import { Drawer } from "antd";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import Button from "shared/components/Button";
import { NAME_SPACES } from "shared/locales/constants";
import Fields from "../Fields";
import { DEFAULT_TARIFF_KEY } from "../form";
import validation from "../validation";

const Create = ({ onSubmit, open, onClose }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DISCOUNT_CODE);
  const CREATE = t("CREATE", { returnObjects: true });
  const FORM = t("FORM", { returnObjects: true });

  return (
    <Drawer
      open={open}
      className="drawer__area"
      title={CREATE.TITLE}
      width={500}
      onClose={onClose}
      placement="right"
    >
      <Formik
        initialValues={{
          code: "",
          tariffKey: DEFAULT_TARIFF_KEY,
          label: "",
          active: true,
          startDate: "",
          endDate: "",
          process: { id: "" },
        }}
        onSubmit={(values, { resetForm }) => {
          onSubmit(values);
          resetForm();
        }}
        validationSchema={validation(
          t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
        )}
      >
        {({ handleSubmit, setFieldValue, values, ...formProps }) => (
          <>
            <Fields
              formProps={formProps}
              values={values}
              setFieldValue={setFieldValue}
              FORM={FORM}
            />
            <div className="mt-16">
              <Button type="primary" size="full--width" onClick={handleSubmit}>
                {FORM.SUBMIT}
              </Button>
            </div>
          </>
        )}
      </Formik>
    </Drawer>
  );
};

export default Create;
